import Pbf from 'pbf'

export type Tile = {
    layers: Layer[]
}

export function tile_encode(tile: Tile, pbf: Pbf) {
    for (const layer of tile.layers) {
        pbf.writeMessage(3, writeTileLayer, layer)
    }
}

export type Value = {
    string_value?: string
    float_value?: number
    double_value?: number
    int_value?: number
    uint_value?: number
    sint_value?: number
    bool_value?: boolean
}

export function writeTileValue(obj: Value, pbf: Pbf) {
    if (obj.string_value != void 0) pbf.writeStringField(1, obj.string_value)
    if (obj.float_value != void 0) pbf.writeFloatField(2, obj.float_value)
    if (obj.double_value != void 0) pbf.writeDoubleField(3, obj.double_value)
    if (obj.int_value != void 0) pbf.writeVarintField(4, obj.int_value)
    if (obj.uint_value != void 0) pbf.writeVarintField(5, obj.uint_value)
    if (obj.sint_value != void 0) pbf.writeSVarintField(6, obj.sint_value)
    if (obj.bool_value != void 0) pbf.writeBooleanField(7, obj.bool_value)
}

export const TileGeomType = {
    UNKNOWN: 0,
    POINT: 1,
    LINESTRING: 2,
    POLYGON: 3,
} as const

export type Feature = {
    id?: number
    tags: number[]
    type: keyof typeof TileGeomType
    geometry: number[]
}

export function writeTileFeature(obj: Feature, pbf: Pbf) {
    if (obj.id != undefined) pbf.writeVarintField(1, obj.id)
    pbf.writePackedVarint(2, obj.tags)
    pbf.writeVarintField(3, TileGeomType[obj.type])
    pbf.writePackedVarint(4, obj.geometry)
}

export type Layer = {
    version: number
    name: string
    features: Feature[]
    keys: string[]
    values: Value[]
    extent?: number
}

export function writeTileLayer(obj: Layer, pbf: Pbf) {
    pbf.writeVarintField(15, obj.version)
    pbf.writeStringField(1, obj.name)

    for (const item of obj.features) {
        pbf.writeMessage(2, writeTileFeature, item)
    }
    for (const item of obj.keys) {
        pbf.writeStringField(3, item)
    }
    for (const item of obj.values) {
        pbf.writeMessage(4, writeTileValue, item)
    }

    if (obj.extent != undefined) {
        pbf.writeVarintField(5, obj.extent)
    }
}
